export enum ErrorMessage {
  DEFAULT = '',
  LOAD_ERROR = 'Unable to load todos',
  TITLE_ERROR = 'Title cannot be empty',
  ADD_ERROR = 'Unable to add a todo',
  DELETE_ERROR = 'Unable to delete a todo',
  UPDATE_ERROR = 'Unable to update a todo',
}
